import { Link, Typography } from "@mui/material";
import { useTenant } from "hooks/useTenant";
import { Link as RouterLink } from "react-router-dom";
import { NO_VALUE } from "routes/Customer/Waste/Invoices/utils";

type InvoiceLine = { invoiceId: string; invoiceNumber?: string | null };

/**
 * The invoices a result's charges sit on, each opening the invoice it names —
 * the number a reader quotes back to the vendor, and the page they open to
 * check it. Read off the charges themselves, so a number is never paired with
 * another invoice's id. An invoice deleted since grading has no number to show.
 */
export function InvoiceLinks({ lines }: { lines: readonly InvoiceLine[] }) {
  const { tenantId } = useTenant();
  const invoices = new Map<string, string>();
  for (const line of lines) {
    if (line.invoiceNumber != null) invoices.set(line.invoiceId, line.invoiceNumber);
  }
  if (invoices.size === 0 || !tenantId) return <>{NO_VALUE}</>;

  return (
    <Typography variant="body2" component="span" sx={{ whiteSpace: "normal" }}>
      {[...invoices].map(([invoiceId, number], index) => (
        <span key={invoiceId}>
          {index > 0 ? ", " : ""}
          <Link
            component={RouterLink}
            to={`/o/${tenantId}/waste/invoices/${invoiceId}`}
            onClick={(event) => event.stopPropagation()}
          >
            {number}
          </Link>
        </span>
      ))}
    </Typography>
  );
}
